import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d42b3a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col relative overflow-hidden bg-white dark:bg-gray-800 shadow-lg rounded-md p-3" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 right-0 pointer-events-none quest-completed"
}
const _hoisted_3 = { class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ml-3 -mt-3" }
const _hoisted_4 = { class: "flex space-x-3 flex-grow" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "font-bold text-lg" }
const _hoisted_7 = {
  key: 1,
  class: "text-gray-600 dark:text-gray-300 text-sm mt-1"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" of users have unlocked ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_BadgeIcon = _resolveComponent("BadgeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.achieved)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_CheckIcon, { class: "text-white w-6" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_BadgeIcon, {
        group: _ctx.group,
        gildClass: _ctx.gildClass,
        class: "w-12 h-12"
      }, null, 8, ["group", "gildClass"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.name), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.description), 1)
      ])
    ]),
    _createElementVNode("span", {
      class: _normalizeClass([_ctx.rarityClass, "px-2 uppercase text-white font-bold text-xs rounded self-start mt-3"])
    }, _toDisplayString(_ctx.rarityName), 3),
    (_ctx.fraction < 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.number.compact(_ctx.fraction * 100)) + "%", 1),
          _hoisted_8
        ]))
      : _createCommentVNode("", true)
  ]))
}